var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 176"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.23291,
    y: 0.754883,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_356_920",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 4.23291,
    y: 4.75488,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_356_920)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "close_2",
    d: "M16.233 18.1547L11.333 23.0547C11.1496 23.238 10.9163 23.3297 10.633 23.3297C10.3496 23.3297 10.1163 23.238 9.93296 23.0547C9.74963 22.8714 9.65796 22.638 9.65796 22.3547C9.65796 22.0714 9.74963 21.838 9.93296 21.6547L14.833 16.7547L9.93296 11.8547C9.74963 11.6714 9.65796 11.438 9.65796 11.1547C9.65796 10.8714 9.74963 10.638 9.93296 10.4547C10.1163 10.2714 10.3496 10.1797 10.633 10.1797C10.9163 10.1797 11.1496 10.2714 11.333 10.4547L16.233 15.3547L21.133 10.4547C21.3163 10.2714 21.5496 10.1797 21.833 10.1797C22.1163 10.1797 22.3496 10.2714 22.533 10.4547C22.7163 10.638 22.808 10.8714 22.808 11.1547C22.808 11.438 22.7163 11.6714 22.533 11.8547L17.633 16.7547L22.533 21.6547C22.7163 21.838 22.808 22.0714 22.808 22.3547C22.808 22.638 22.7163 22.8714 22.533 23.0547C22.3496 23.238 22.1163 23.3297 21.833 23.3297C21.5496 23.3297 21.3163 23.238 21.133 23.0547L16.233 18.1547Z",
    fill: "#7E8488"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXButton);
export default __webpack_public_path__ + "static/media/x_button.3096468d249baa589a34fdd912da12f1.svg";
export { ForwardRef as ReactComponent };